/* global window */
import Cookies from 'js-cookie';
import queryString from 'query-string';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { convertStringToInteger } from 'common/helpers/numberHelper';
import {
  addCouponOrGiftCard,
  addCartItem,
  updateCart
} from 'redux/cart/actions';

const UrlWidgets = () => {
  const dispatch = useDispatch();

  const qString = queryString.extract(window.location.href);
  const queryObj = queryString.parse(qString);

  const { couponCode, addToCart, checkout, quantity, c7EmailId } = queryObj;

  let isExecute = false;

  let addToCartFunction = () => {};
  if (addToCart) {
    isExecute = true;
    let successFunction = () => {
      //
    };
    if (checkout) {
      successFunction = () => {
        window.location.href = '/checkout';
      };
    }

    const q = (quantity && convertStringToInteger(quantity)) || 1;

    const item = {
      sku: addToCart,
      quantity: q
    };
    const analytics = {
      viewType: 'URL Widget'
    };
    addToCartFunction = () => {
      dispatch(addCartItem(item, analytics, successFunction));
    };
  }

  let addCouponFunction = () => {
    addToCartFunction();
  };

  if (couponCode) {
    isExecute = true;
    const errorFunction = () => {
      // fail silently
      addToCartFunction();
    };
    const successFunction = () => {
      addToCartFunction();
    };
    addCouponFunction = () => {
      dispatch(addCouponOrGiftCard(couponCode, successFunction, errorFunction));
    };
  }

  let metaDataFunction = () => {
    addCouponFunction();
  };
  if (Object.keys(queryObj).length) {
    const cart = {};
    let isMeta = false;
    const metaData = {};

    // meta_ parameters
    const metaArray = Object.keys(queryObj).filter(
      (k) => k.substring(0, 4) === 'meta'
    );
    metaArray.forEach((metaElement) => {
      metaData[metaElement.substring(5)] = queryObj[metaElement];
    });

    // mailchimp parameter
    if (queryObj.mc_cid) {
      metaData.mc_cid = queryObj.mc_cid;
    }
    if (Object.keys(metaData).length) {
      isExecute = true;
      isMeta = true;
      cart.metaData = metaData;
      Cookies.set('c7metaData', JSON.stringify(metaData), {
        secure: process.env.NODE_ENV === 'production'
      });
    }
    if (c7EmailId) {
      isExecute = true;
      isMeta = true;
      Cookies.set('c7EmailId', c7EmailId, {
        secure: process.env.NODE_ENV === 'production'
      });
      cart.additionalInfo = {
        emailId: c7EmailId
      };
    }
    if (isMeta && Cookies.get('cartId')) {
      const successFunction = () => {
        addCouponFunction();
      };
      const errorFunction = () => {
        addCouponFunction();
      };
      metaDataFunction = () => {
        dispatch(updateCart(cart, successFunction, errorFunction));
      };
    }
  }

  // Trigger to update functions
  useEffect(() => {
    if (isExecute) {
      metaDataFunction();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExecute]);

  return null;
};

export default UrlWidgets;
